"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AstronomicalObject_1 = __importDefault(require("../astronomicalObject/AstronomicalObject"));
var calculationCache_1 = require("../cache/calculationCache");
var standardAltitude_1 = require("../constants/standardAltitude");
var apparentCoordinateCalc_1 = require("../coordinates/calculations/apparentCoordinateCalc");
var coordinateCalc_1 = require("../coordinates/calculations/coordinateCalc");
var earth_1 = require("../earth");
var sun_1 = require("../sun");
var time_1 = require("../time");
var utils_1 = require("../utils");
var angleCalc_1 = require("../utils/angleCalc");
var riseSetTransitCalc_1 = require("../utils/riseSetTransitCalc");
var vsop87Calc_1 = require("./calculations/vsop87Calc");
var Planet = (function (_super) {
    __extends(Planet, _super);
    function Planet(toi, name, useVsop87Short) {
        if (toi === void 0) { toi = time_1.createTimeOfInterest.fromCurrentTime(); }
        if (name === void 0) { name = 'planet'; }
        if (useVsop87Short === void 0) { useVsop87Short = false; }
        var _this = _super.call(this, toi, name) || this;
        _this.toi = toi;
        _this.name = name;
        _this.useVsop87Short = useVsop87Short;
        _this.sun = (0, sun_1.createSun)(toi);
        _this.earth = (0, earth_1.createEarth)(toi);
        return _this;
    }
    Planet.prototype.getHeliocentricEclipticSphericalJ2000Coordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, calculationCache_1.getAsyncCachedCalculation)(this.name + '_heliocentric_spherical_j2000', this.t, function () { return __awaiter(_this, void 0, void 0, function () {
                            var vsop87;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, this.vsop87J2000];
                                    case 1:
                                        vsop87 = _a.sent();
                                        return [2, {
                                                lon: (0, angleCalc_1.normalizeAngle)((0, vsop87Calc_1.calculateVSOP87Angle)(vsop87.VSOP87_X, this.t)),
                                                lat: (0, vsop87Calc_1.calculateVSOP87Angle)(vsop87.VSOP87_Y, this.t),
                                                radiusVector: (0, vsop87Calc_1.calculateVSOP87)(vsop87.VSOP87_Z, this.t),
                                            }];
                                }
                            });
                        }); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Planet.prototype.getHeliocentricEclipticSphericalDateCoordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, calculationCache_1.getAsyncCachedCalculation)(this.name + '_heliocentric_spherical_date', this.t, function () { return __awaiter(_this, void 0, void 0, function () {
                            var vsop87, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!this.useVsop87Short) return [3, 2];
                                        return [4, this.vsop87DateShort];
                                    case 1:
                                        _a = _b.sent();
                                        return [3, 4];
                                    case 2: return [4, this.vsop87Date];
                                    case 3:
                                        _a = _b.sent();
                                        _b.label = 4;
                                    case 4:
                                        vsop87 = _a;
                                        return [2, {
                                                lon: (0, angleCalc_1.normalizeAngle)((0, vsop87Calc_1.calculateVSOP87Angle)(vsop87.VSOP87_X, this.t)),
                                                lat: (0, vsop87Calc_1.calculateVSOP87Angle)(vsop87.VSOP87_Y, this.t),
                                                radiusVector: (0, vsop87Calc_1.calculateVSOP87)(vsop87.VSOP87_Z, this.t),
                                            }];
                                }
                            });
                        }); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Planet.prototype.getAngularDiameter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var distance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getApparentDistanceToEarth()];
                    case 1:
                        distance = _a.sent();
                        return [2, utils_1.observationCalc.getAngularDiameter(distance, this.diameter)];
                }
            });
        });
    };
    Planet.prototype.getApparentMagnitude = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coordsHelio, coordsGeo, phaseAngle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getHeliocentricEclipticSphericalDateCoordinates()];
                    case 1:
                        coordsHelio = _a.sent();
                        return [4, this.getGeocentricEclipticSphericalDateCoordinates()];
                    case 2:
                        coordsGeo = _a.sent();
                        return [4, this.getPhaseAngle()];
                    case 3:
                        phaseAngle = _a.sent();
                        return [2, this.calculateApparentMagnitude(coordsHelio.radiusVector, coordsGeo.radiusVector, phaseAngle)];
                }
            });
        });
    };
    Planet.prototype.getHeliocentricEclipticRectangularJ2000Coordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getHeliocentricEclipticSphericalJ2000Coordinates()];
                    case 1:
                        coords = _a.sent();
                        return [2, (0, coordinateCalc_1.spherical2rectangular)(coords)];
                }
            });
        });
    };
    Planet.prototype.getHeliocentricEclipticRectangularDateCoordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getHeliocentricEclipticSphericalDateCoordinates()];
                    case 1:
                        coords = _a.sent();
                        return [2, (0, coordinateCalc_1.spherical2rectangular)(coords)];
                }
            });
        });
    };
    Planet.prototype.getGeocentricEclipticRectangularJ2000Coordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coordsPlanet, coordsEarth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getHeliocentricEclipticRectangularJ2000Coordinates()];
                    case 1:
                        coordsPlanet = _a.sent();
                        return [4, this.earth.getHeliocentricEclipticRectangularJ2000Coordinates()];
                    case 2:
                        coordsEarth = _a.sent();
                        return [2, (0, coordinateCalc_1.rectangularHeliocentric2rectangularGeocentric)(coordsPlanet, coordsEarth)];
                }
            });
        });
    };
    Planet.prototype.getGeocentricEclipticRectangularDateCoordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coordsPlanet, coordsEarth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getHeliocentricEclipticRectangularDateCoordinates()];
                    case 1:
                        coordsPlanet = _a.sent();
                        return [4, this.earth.getHeliocentricEclipticRectangularDateCoordinates()];
                    case 2:
                        coordsEarth = _a.sent();
                        return [2, (0, coordinateCalc_1.rectangularHeliocentric2rectangularGeocentric)(coordsPlanet, coordsEarth)];
                }
            });
        });
    };
    Planet.prototype.getGeocentricEclipticSphericalJ2000Coordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getGeocentricEclipticRectangularJ2000Coordinates()];
                    case 1:
                        coords = _a.sent();
                        return [2, (0, coordinateCalc_1.rectangular2spherical)(coords)];
                }
            });
        });
    };
    Planet.prototype.getGeocentricEclipticSphericalDateCoordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getGeocentricEclipticRectangularDateCoordinates()];
                    case 1:
                        coords = _a.sent();
                        return [2, (0, coordinateCalc_1.rectangular2spherical)(coords)];
                }
            });
        });
    };
    Planet.prototype.getApparentGeocentricEclipticSphericalCoordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getLightTimeCorrectedEclipticSphericalCoordinates()];
                    case 1:
                        coords = _a.sent();
                        coords = (0, apparentCoordinateCalc_1.correctEffectOfAberration)(coords, this.T);
                        coords = (0, apparentCoordinateCalc_1.correctEffectOfNutation)(coords, this.T);
                        return [2, coords];
                }
            });
        });
    };
    Planet.prototype.getTransit = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var jd;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, riseSetTransitCalc_1.getTransit)(this.constructor, location, this.jd0)];
                    case 1:
                        jd = _a.sent();
                        return [2, time_1.createTimeOfInterest.fromJulianDay(jd)];
                }
            });
        });
    };
    Planet.prototype.getRise = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var jd;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, riseSetTransitCalc_1.getRise)(this.constructor, location, this.jd0, standardAltitude_1.STANDARD_ALTITUDE_PLANET_REFRACTION)];
                    case 1:
                        jd = _a.sent();
                        return [2, time_1.createTimeOfInterest.fromJulianDay(jd)];
                }
            });
        });
    };
    Planet.prototype.getSet = function (location) {
        return __awaiter(this, void 0, void 0, function () {
            var jd;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, riseSetTransitCalc_1.getSet)(this.constructor, location, this.jd0, standardAltitude_1.STANDARD_ALTITUDE_PLANET_REFRACTION)];
                    case 1:
                        jd = _a.sent();
                        return [2, time_1.createTimeOfInterest.fromJulianDay(jd)];
                }
            });
        });
    };
    Planet.prototype.getElongation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords, coordsSun;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getApparentGeocentricEquatorialSphericalCoordinates()];
                    case 1:
                        coords = _a.sent();
                        return [4, this.sun.getApparentGeocentricEquatorialSphericalCoordinates()];
                    case 2:
                        coordsSun = _a.sent();
                        return [2, utils_1.observationCalc.getElongation(coords, coordsSun)];
                }
            });
        });
    };
    Planet.prototype.getPhaseAngle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coords, coordsSun;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getApparentGeocentricEquatorialSphericalCoordinates()];
                    case 1:
                        coords = _a.sent();
                        return [4, this.sun.getApparentGeocentricEquatorialSphericalCoordinates()];
                    case 2:
                        coordsSun = _a.sent();
                        return [2, utils_1.observationCalc.getPhaseAngle(coords, coordsSun)];
                }
            });
        });
    };
    Planet.prototype.getIlluminatedFraction = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getPhaseAngle()];
                    case 1:
                        i = _a.sent();
                        return [2, utils_1.observationCalc.getIlluminatedFraction(i)];
                }
            });
        });
    };
    Planet.prototype.getPositionAngleOfBrightLimb = function () {
        return __awaiter(this, void 0, void 0, function () {
            var coordsPlanet, coordsSun;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getApparentGeocentricEquatorialSphericalCoordinates()];
                    case 1:
                        coordsPlanet = _a.sent();
                        return [4, this.sun.getApparentGeocentricEquatorialSphericalCoordinates()];
                    case 2:
                        coordsSun = _a.sent();
                        return [2, utils_1.observationCalc.getPositionAngleOfBrightLimb(coordsPlanet, coordsSun)];
                }
            });
        });
    };
    Planet.prototype.isWaxing = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chi;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getPositionAngleOfBrightLimb()];
                    case 1:
                        chi = _a.sent();
                        return [2, utils_1.observationCalc.isWaxing(chi)];
                }
            });
        });
    };
    Planet.prototype.getLightTimeCorrectedEclipticSphericalCoordinates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var radiusVector, jd, toi, planet, helRecEarthCoords, helRecPlanetCoords, coords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getGeocentricEclipticSphericalDateCoordinates()];
                    case 1:
                        radiusVector = (_a.sent()).radiusVector;
                        jd = (0, apparentCoordinateCalc_1.getLightTimeCorrectedJulianDay)(this.jd, radiusVector);
                        toi = time_1.createTimeOfInterest.fromJulianDay(jd);
                        planet = new this.constructor(toi);
                        return [4, this.earth.getHeliocentricEclipticRectangularDateCoordinates()];
                    case 2:
                        helRecEarthCoords = _a.sent();
                        return [4, planet.getHeliocentricEclipticRectangularDateCoordinates()];
                    case 3:
                        helRecPlanetCoords = _a.sent();
                        coords = (0, coordinateCalc_1.rectangularHeliocentric2rectangularGeocentric)(helRecPlanetCoords, helRecEarthCoords);
                        return [2, (0, coordinateCalc_1.rectangular2spherical)(coords)];
                }
            });
        });
    };
    return Planet;
}(AstronomicalObject_1.default));
exports.default = Planet;
